import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class imagesView_template extends vnTemplate {
    protected getTemplateHtml(): string {
        return /* html */`
                <div class="w-form w-image-view w-form-large ">

                    <div class="form-header">
                        <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                        <!-- ko if: permissions() && permissions()['article_edit']  && permissions()['article_edit'].read -->
                        <button data-bind="event: { click: onClickEdit }, disabled: !isEditShown" class="btn icon i-edit" type="button">Edit Image</button>
                        <!-- /ko -->
                    </div>

                    <div class="w-form-body">
                        <div class="form-body">
                            <strong class="form-sub-title">Upload</strong>
                            <div class="form-group inside-label">
                                <label for="url" class="form-label">Image</label>
                                <div class="w-img">
                                <!-- ko if: url !== null -->
                                    <img data-bind="attr: {src: url  }" style="max-height: 10rem;">
                                <!-- /ko -->
                                </div>
                                <input id="url" data-bind="value: url" type="hidden">
                            </div>
                            <div class="form-group">
                                <dl class="double-list">
                                    <dt style="grid-column: 1 / span 2"><span>URL</span></dt><dd class="flex" style="grid-column: 1 / span 2;text-align: left;border-bottom: 0px solid black"><span class="no-cap" data-bind="text: url"></span><a style="margin-left: 1rem;" class="btn icon border only-icon i-full-size" target="_blank" rel="noopener noreferrer" data-bind="attr: { href: url }"></a></dd>
                                    <dt><span>Size</span></dt><dd><span data-bind="text: sizeHuman"></span></dd>
                                    <dt><span>Dimension</span></dt><dd><span data-bind="text: width"></span><span class="no-cap">px&nbsp;x&nbsp;</span><span data-bind="text: height"></span><span class="no-cap">px</span></dd>
                                    <dt><span>Ratio</span></dt><dd><span data-bind="text: ratio"></span></dd>
                                    <dt><span>Enhanced</span></dt><dd><span style="white-space: nowrap" data-bind="text: isAiTouched()"></span></dd>
                                    <dt><span>MIME Type</span></dt><dd><span class="no-cap" data-bind="text: mimeType"></span></dd>
                                    <dt><span>Date Uploaded</span></dt><dd><span data-bind="text: dateCreated"></span></dd>
                                    <dt><span>Date Updated</span></dt><dd><span data-bind="text: dateUpdated"></span></dd>
                                </dl>
                            </div>
                        </div>
                        <div class="form-body">
                            <strong class="form-sub-title">Image Information</strong>
                            <div class="form-group">
                                <dl class="double-list">
                                    <dt><span>Name</span></dt>
                                    <dd><span data-bind="text: name"></span></dd>

                                    <dt><span>Credit Text</span></dt>
                                    <dd><span data-bind="html: caption"></span></dd>

                                    <dt class="full-width">
                                        <span>Description</span>
                                    </dt>
                                    <dd class="full-width">
                                        <span class="no-cap"
                                            style="text-align: left;font-weight: normal;"
                                            data-bind="html: description"
                                        ></span>
                                    </dd>

                                    <dt class="full-width"><span>Alternate Image Text</span></dt>
                                    <dd class="full-width"><span data-bind="text: altText"></span></dd>

                                    <dt class="full-width">
                                        <span>Tags</span>
                                    </dt>
                                    <dd class="full-width">
                                        <!-- ko if: !imageTags() || imageTags().length == 0 -->
                                            <span class="no-cap"
                                                data-bind="text: 'None'"
                                            ></span>
                                        <!-- /ko -->
                                        <!-- ko foreach: imageTags -->
                                            <div class="no-cap"
                                                data-bind="
                                                    text: $data.tag.idType? $data.tag.name + ' ' + $data.tag.formattedTagTypeAndDataset : $data.tag.name,
                                                    style: { 'font-weight': $parent.isTagIdPrimaryTag($data.tag.id)? 'bold' : 'normal' }
                                                "
                                            ></div>
                                        <!-- /ko -->
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            `;
    }

    protected initPartial(): void { }

    protected getTemplateName(): string {
        return "imagesView-template";
    }

    protected buildViewModel(): any {
        let self = this;

        return {
            id: ko.observable(""),
            name: ko.observable(""),
            description: ko.observable(""),
            caption: ko.observable(""),
            altText: ko.observable(""),
            url: ko.observable(""),
            length: ko.observable(""),
            size: ko.observable(""),
            sizeHuman: ko.observable(""),
            height: ko.observable(""),
            width: ko.observable(""),
            ratio: ko.observable(""),
            mimeType: ko.observable(""),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),
            isEditShown: ko.observable(false),
            lockItem: ko.observable(false),
            primaryTag: ko.observable(""),
            imageTags: ko.observableArray([]),
            isAiEnhanced: ko.observable(true),
            isHdrAdjusted: ko.observable(true),
            permissions: ko.observableArray(this.initPermissions(["article_edit_embargo", 'article_edit'])),
            onClickEdit: (data) => {
                self.onClickEdit(data.id());
            },
            onClickCancel: (data, event) => {
                self.onClickCancel();
            },
            isTagIdPrimaryTag: (tagId) => self.getTemplateViewModel().primaryTag()? tagId === self.getTemplateViewModel().primaryTag().id : false,
            isAiTouched: function () {
                let anyIsOn = false;
                let whichIsOn = [];
                if (this.isAiEnhanced()) {
                    whichIsOn.push('Upscaled');
                    anyIsOn = true;
                }

                if (this.isHdrAdjusted()) {
                    whichIsOn.push('HDR Color Adjusted');
                    anyIsOn = true;
                }

                if (!anyIsOn) {
                    return "No";
                } else {
                    return `Yes (${whichIsOn.join(', ')})`;
                }
            },
        };
    }

    public setPermissions(permissions)
    {
        this.getTemplateViewModel().permissions(permissions);
    }

    public getViewModelForRequest() {
        return {
            lockItem: this.getTemplateViewModel().lockItem,
        };
    }

    public onClickEdit(id) {
        this.caller.edit(id);
    }

    protected onClickCancel() {
        this.caller.goBack();
    }

    public setId(id): void {
        this.getTemplateViewModel().id(id);
    }

    public setName(name): void {
        this.getTemplateViewModel().name(name);
    }

    public setDescription(description): void {
        this.getTemplateViewModel().description(description);
    }

    public setCaption(caption): void {
        this.getTemplateViewModel().caption(caption);
    }

    public setAltText(altText): void {
        this.getTemplateViewModel().altText(altText);
    }

    public setUrl(url): void {
        this.getTemplateViewModel().url(url);
    }

    public setIsAiEnhanced(isAiEnhanced): void {
        this.getTemplateViewModel().isAiEnhanced(isAiEnhanced);
    }

    public setIsHdrAdjusted(isHdrAdjusted): void {
        this.getTemplateViewModel().isHdrAdjusted(isHdrAdjusted);
    }

    public setLength(length): void {
        this.getTemplateViewModel().length(length);
    }

    public setSize(size): void {
        this.getTemplateViewModel().size(size);
    }

    public setSizeHuman(size): void {
        this.getTemplateViewModel().sizeHuman(this.formatBytes(size));
    }

    public setHeight(height): void {
        this.getTemplateViewModel().height(height);
    }

    public setWidth(width): void {
        this.getTemplateViewModel().width(width);
    }

    public setRatio(ratio): void {
        this.getTemplateViewModel().ratio(ratio);
    }

    public setMimeType(mimeType): void {
        this.getTemplateViewModel().mimeType(mimeType);
    }

    public setDateCreated(dateCreated): void {
        this.getTemplateViewModel().dateCreated(dateCreated);
    }

    public setDateUpdated(dateUpdated): void {
        this.getTemplateViewModel().dateUpdated(dateUpdated);
    }

    public setIsEditShown(isEditShown): void {
        this.getTemplateViewModel().isEditShown(isEditShown);
    }

    public setImageTags(imageTags): void {
        this.getTemplateViewModel().imageTags(imageTags);
    }

    public setPrimaryTag(primaryTag): void {
        this.getTemplateViewModel().primaryTag(primaryTag);
    }

    public formatBytes(bytes, decimals = 2, binaryUnits = 1024) {
        if (bytes == 0) {
            return "0 Bytes";
        }
        var unitMultiple = binaryUnits ? 1024 : 1000;
        var unitNames =
            unitMultiple === 1024 // 1000 bytes in 1 Kilobyte (KB) or 1024 bytes for the binary version (KiB)
                ? ["Bytes", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
                : ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        var unitChanges = Math.floor(Math.log(bytes) / Math.log(unitMultiple));
        return (
            parseFloat((bytes / Math.pow(unitMultiple, unitChanges)).toFixed(decimals || 0)) +
            " " +
            unitNames[unitChanges]
        );
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/imagesView_template.ts